import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "@coworker/locales";
import { useTextAreaPopup } from "./_common";
import { isIOS } from "../../helpers/browserChecks";
import Button from "@coworker/components/src/components/Button";
import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";

const ButtonWrapper = styled("div")`
  box-sizing: border-box;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 106px;
  padding-bottom: 10px;
`;
const Container = styled("div")`
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  height: calc(100% - 50px);
  width: 100%;
  top: 0;
  left: 0;
  background: var(--white);
  margin-top: 50px;
  overflow-y: auto;
`;
const TitleText = styled("div")`
  margin-top: 128px;
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--grey900);
  margin: 12px 30px;
  @media (min-height: ${isIOS ? "758px" : "500px"}) {
    margin: 55px 30px;
  }
`;
const StyledButton = styled(Button)`
  margin: 20px 30px;
  width: 100%;
`;
const Counter = styled("div")`
  color: var(--grey500);
  width: 100%;
  font-size: 12px;
  margin-left: 30px;
  margin-bottom: 20px;
  margin-top: 12px;
  @media (min-height: ${isIOS ? "758px" : "500px"}) {
    margin-top: 48px;
  }
`;
const StyledTextArea = styled(FixaTextArea)`
  margin: 0px 30px;
`;
const Grower = styled("div")`
  flex-grow: 1;
`;

const Title = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(props.initialValue);
  const containerRef = React.useRef(null);
  const { textArea, onFocus, onBlur } = useTextAreaPopup(containerRef, value, {
    lineHeight: 19,
    verticalPadding: 60,
    initialLines: 1,
  });
  const maxLength = 150;
  const currentLength = value ? value.length : 0;

  React.useEffect(() => {
    if (value && maxLength < value.length) {
      setValue(value.slice(0, maxLength));
    }
  }, [value, maxLength]);

  return (
    <Container ref={containerRef} data-testid="customTitleModal">
      <TitleText>
        <Trans>addtitleHeadlineString</Trans>
      </TitleText>
      <Counter>
        {currentLength}/{maxLength}
      </Counter>
      <StyledTextArea
        label={t("titleString")}
        onChange={(e) => setValue(e.target.value)}
        ref={textArea}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        data-testid="titleInput"
        maxLength={maxLength}
      />
      <Grower />
      <ButtonWrapper>
        <StyledButton
          customMargin
          type="submit"
          text={<Trans>continue2String</Trans>}
          primary={true}
          dark={true}
          disabled={!value}
          onClick={(event) => {
            event.preventDefault();
            props.onSubmit(value);
          }}
          data-testid="titleButton"
        />
      </ButtonWrapper>
    </Container>
  );
};

export default Title;
